import { NgModule } from '@angular/core';
import { SharedModule } from '../shared/shared.module';
import { MyAccountComponent } from './components/my-account/my-account.component';
import { RouterModule } from '@angular/router';
import { routes } from './user.routes';

@NgModule({
  declarations: [
    MyAccountComponent
  ],
  providers: [
  ],
  imports: [
    SharedModule,
    RouterModule.forChild(routes)
  ]
})
export class UserModule {

  public constructor() {

  }

}
